<template>
  <div class="uni-popup-share">
    <div class="uni-share-title">
      <span class="uni-share-title-text">{{ shareTitleText }}</span>
    </div>
    <div class="uni-share-content">
      <div class="uni-share-content-box">
        <div
          class="uni-share-content-item"
          v-for="(item, index) in bottomData"
          :key="index"
          @click.stop="select(item, index)"
        >
          <img class="uni-share-image" :src="item.icon" mode="aspectFill" />
          <span class="uni-share-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="uni-share-button-box">
      <button class="uni-share-button" @click="close">{{ cancelText }}</button>
    </div>
  </div>
</template>

<script>
import popup from '../uni-popup/popup.js'
// import { initVueI18n } from '@dcloudio/uni-i18n'
import messages from '../uni-popup/i18n/index.js'
// const { t } = initVueI18n(messages)
export default {
  name: 'UniPopupShare',
  mixins: [popup],
  emits: ['select'],
  props: {
    title: {
      type: String,
      default: ''
    },
    beforeClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bottomData: [
        {
          text: '微信',
          icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/c2b17470-50be-11eb-b680-7980c8a877b8.png',
          name: 'wx'
        },
        {
          text: '支付宝',
          icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/d684ae40-50be-11eb-8ff1-d5dcf8779628.png',
          name: 'wx'
        },
        {
          text: 'QQ',
          icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/e7a79520-50be-11eb-b997-9918a5dda011.png',
          name: 'qq'
        },
        {
          text: '新浪',
          icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/0dacdbe0-50bf-11eb-8ff1-d5dcf8779628.png',
          name: 'sina'
        }
        // {
        // 	text: '百度',
        // 	icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/1ec6e920-50bf-11eb-8a36-ebb87efcf8c0.png',
        // 	name: 'copy'
        // },
        // {
        // 	text: '其他',
        // 	icon: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/2e0fdfe0-50bf-11eb-b997-9918a5dda011.png',
        // 	name: 'more'
        // }
      ]
    }
  },
  created() {},
  computed: {
    cancelText() {
      return t('uni-popup.cancel')
    },
    shareTitleText() {
      return this.title || t('uni-popup.shareTitle')
    }
  },
  methods: {
    /**
     * 选择内容
     */
    select(item, index) {
      this.$emit('select', {
        item,
        index
      })
      this.close()
    },
    /**
     * 关闭窗口
     */
    close() {
      if (this.beforeClose) return
      this.popup.close()
    }
  }
}
</script>
<style lang="scss">
.uni-popup-share {
  background-color: #fff;
  border-top-left-radius: 0.234667rem;
  border-top-right-radius: 0.234667rem;
}
.uni-share-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 0.853333rem;
}
.uni-share-title-text {
  font-size: 0.298667rem;
  color: #666;
}
.uni-share-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 0.213333rem;
}

.uni-share-content-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 7.68rem;
}

.uni-share-content-item {
  width: 1.92rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.213333rem 0;
  align-items: center;
}

.uni-share-content-item:active {
  background-color: #f5f5f5;
}

.uni-share-image {
  width: 0.64rem;
  height: 0.64rem;
}

.uni-share-text {
  margin-top: 0.213333rem;
  font-size: 0.298667rem;
  color: #3b4144;
}

.uni-share-button-box {
  display: flex;
  flex-direction: row;
  padding: 0.213333rem 0.32rem;
}

.uni-share-button {
  flex: 1;
  border-radius: 1.066667rem;
  color: #666;
  font-size: 0.341333rem;
}

.uni-share-button::after {
  border-radius: 1.066667rem;
}
</style>
